/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Botonera from '../../components/atoms/Footer';
import { sucursalActions } from '../../../application/actions/sucursal';
import SucursalesTemplate from '../../components/templates/Sucursal';
import { properties } from '../../../utils/properties';
import TagManagerUtils from '../../../utils/TagManagerUtils';
import { verificacionActions } from '../../../application/actions/verificacion';
import { ofertaActions } from '../../../application/actions/oferta';
import { encryptStorage } from '../../../utils/EncryptStorage';
import { TipoProducto } from '../../../utils/TipoProducto';
import ModalEncuestaAbandono from '../../components/organisms/ModalEncuestaAbandono';
import ModalRespuestaEncuesta from '../../components/organisms/ModalRespuestaEncuesta';

const Step4 = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [comunaAux, setComunaAux] = useState({});
  const [regionAux, setRegionAux] = useState({});

  const [direccion, setDireccion] = useState({
    region: '',
    comuna: '',
    buscarSucursalCercana: false,
  });

  const [openModalEncuestaAbandono, setOpenModalEncuestaAbandono] = useState(false);
  const [openModalRespuestaEncuesta, setOpenModalRespuestaEncuesta] = useState(false);
  const [tipoRespuesta, setTipoRespuesta] = useState('');
  const [encuestaRespondida, setEncuestaRespondida] = useState(false); // pendiente backend

  const [state] = useState({
    menuPosition: 4,
    arraydeBotones: [
      {
        nameUno: properties.pasos.paso4.aceptarButton,
        nameDos: properties.pasos.paso4.volverBoton,
      },
    ],
  });

  const sucursalesFromStore = useSelector((store) => store.entities.sucursal.response);
  const sucursalSelectedFromStore = useSelector(
    (store) => store.entities.sucursal.sucursalSelected
  );
  const responseSaveFromStore = useSelector((store) => store.entities.sucursal.responseSave);
  const storeDataVerificacion = useSelector((store) => store.entities.verificacion.response);
  const storeDataOferta = useSelector((store) => store.entities.oferta.response);

  useEffect(() => {
    if (storeDataVerificacion.length === 0) {
      dispatch(
        verificacionActions.verificacion({
          trackId: window.localStorage.getItem('track_id'),
          solicitudAprobada: true,
        })
      );
    }
    if (storeDataOferta.length === 0) {
      dispatch(ofertaActions.ofertaCreate({ trackId: window.localStorage.getItem('track_id') }));
    }
    if (!responseSaveFromStore || responseSaveFromStore.length === 0) {
      dispatch(sucursalActions.saveSucursal({ trackId: window.localStorage.getItem('track_id') }));
    }
    if (!sucursalesFromStore || sucursalesFromStore.length === 0) {
      dispatch(
        sucursalActions.sucursalServicio({ trackId: window.localStorage.getItem('track_id') })
      );
    }
  }, []);

  const tipoTarjetaFn = () => {
    let dataPersist = {};
    if ('data' in storeDataVerificacion) dataPersist = storeDataVerificacion;
    if ('data' in storeDataOferta) dataPersist = storeDataOferta;

    const { data } = dataPersist;
    const { tipoTarjeta } = data;

    let tarjeta;
    if (tipoTarjeta === TipoProducto.black) {
      tarjeta = 'Mastercard Internacional Negra';
    } else {
      tarjeta = 'Mastercard Internacional Dorada';
    }
    return tarjeta;
  };

  const handleConfirmarBtn = () => {
    const { token, socio, convenio } = storeDataVerificacion;
    const { codigoOficina } = sucursalSelectedFromStore;
    if (socio && convenio) {
      TagManagerUtils.triggerEventMetodoTwo(
        'trigger_event',
        'Socio convenio',
        '/solicitud-tarjeta-credito/paso4',
        'Click',
        'Confirmar solicitud',
        tipoTarjetaFn()
      );
    } else {
      TagManagerUtils.triggerEventMetodoTwo(
        'trigger_event',
        'Socio',
        '/solicitud-tarjeta-credito/paso4',
        'Click',
        'Confirmar solicitud',
        tipoTarjetaFn()
      );
    }
    dispatch(
      sucursalActions.saveSucursal({
        codSucursal: codigoOficina,
        codComuna: comunaAux,
        codRegion: regionAux,
        token,
      })
    );
  };

  const handleVolver = () => {
    window.location.href = properties.urlCoopeuch;
    const { data } = storeDataVerificacion;
    const { socio, convenio } = data;

    if (socio && convenio) {
      const TextoSocio = 'Socio convenio';
      TagManagerUtils.triggerEventMetodo(
        'trigger_event',
        TextoSocio,
        '/sucursal',
        'Click',
        'Volver a coopeuch.cl'
      );
    } else if (socio) {
      const TextoSocio = 'Socio';
      TagManagerUtils.triggerEventMetodo(
        'trigger_event',
        TextoSocio,
        '/sucursal',
        'Click',
        'Volver a coopeuch.cl'
      );
    } else {
      const TextoSocio = 'No Socio';
      TagManagerUtils.triggerEventMetodo(
        'trigger_event',
        TextoSocio,
        '/sucursal',
        'Click',
        'Volver a coopeuch.cl'
      );
    }
  };

  useEffect(() => {
    if (sucursalesFromStore && 'code' in sucursalesFromStore && sucursalesFromStore.code === -1) {
      window.localStorage.setItem('paso', '/sucursal');
      history.push('/error-conexion');
    }
  }, [sucursalesFromStore]);

  useEffect(() => {
    if ('code' in storeDataVerificacion && storeDataVerificacion.code === -1) {
      window.localStorage.setItem('paso', '/sucursal');
      history.push('/error-conexion');
    }
    TagManagerUtils.vpvMetodo('vpv', '/solicitud-tarjeta-credito/paso4', 'Socio');
  }, [storeDataVerificacion]);

  useEffect(() => {
    if (
      !responseSaveFromStore ||
      ('code' in responseSaveFromStore && responseSaveFromStore.code === -1)
    ) {
      window.localStorage.setItem('paso', '/sucursal');
      history.push('/error-conexion');
    } else {
      const { code } = responseSaveFromStore;
      let nuevoPath = '/';
      if (code !== undefined) {
        switch (code) {
          case -1:
            localStorage.setItem('paso', '/sucursal');
            history.push('/error-conexion');
            break;
          case 0:
            nuevoPath = '/comprobante';
            encryptStorage.setItem('p', nuevoPath);
            history.push(nuevoPath);
            break;
          case 30:
            nuevoPath = '/solicitud-en-proceso';
            encryptStorage.setItem('p', nuevoPath);
            history.push(nuevoPath);
            break;
          default:
            encryptStorage.setItem('p', nuevoPath);
            history.push('/error');
            break;
        }
      }
    }
  }, [responseSaveFromStore]);

  useEffect(() => {
    try {
      if ('code' in storeDataOferta && storeDataOferta.code === -1) {
        window.localStorage.setItem('paso', '/sucursal');
        history.push('/error-conexion');
      }
      if (storeDataOferta.code === -1) {
        history.push('/error-conexion');
      }
      let dataPersist = {};
      if ('data' in storeDataVerificacion) dataPersist = storeDataVerificacion;
      if ('data' in storeDataOferta) dataPersist = storeDataOferta;
      if (Object.keys(dataPersist).length) {
        const { data } = dataPersist;
        const { codRegion, codComuna, buscarSucursalCercana } = data;
        setDireccion({
          region: codRegion,
          comuna: codComuna,
          buscarSucursalCercana,
        });
      }
    } catch (error) {
      // caso borde sin respuesta de validar u oferta
      window.location.replace('/');
    }
  }, [storeDataOferta, storeDataVerificacion]);

  const volverACoopeuch = () => {
    window.location.href = properties.urlCoopeuch;
  };

  const retomarEncuesta = () => {
    setOpenModalEncuestaAbandono(true);
    setOpenModalRespuestaEncuesta(false);
  };

  const { menuPosition, arraydeBotones } = state;
  return (
    <>
      {direccion.region !== '' && direccion.comuna !== '' && sucursalesFromStore.length > 0 && (
        <>
          <SucursalesTemplate
            region={direccion.region}
            comuna={direccion.comuna}
            buscarSucursalCercana={direccion.buscarSucursalCercana}
            regiones={sucursalesFromStore}
            activeMenu={menuPosition}
            setComunaAux={setComunaAux}
            setRegionAux={setRegionAux}
          />
          <Botonera
            tituloboton={arraydeBotones}
            estadoBotonUno={sucursalSelectedFromStore !== null}
            estadoBotonDos={false}
            verificarFunction={handleConfirmarBtn}
            volverHome={
              process.env.REACT_APP_HABILITAR_ENCUESTAS === 'true'
                ? setOpenModalEncuestaAbandono
                : volverACoopeuch
            }
          />
          {openModalEncuestaAbandono && (
            <ModalEncuestaAbandono
              setTipoRespuesta={setTipoRespuesta}
              setOpenModalEncuestaAbandono={setOpenModalEncuestaAbandono}
              setOpenModalRespuestaEncuesta={setOpenModalRespuestaEncuesta}
              setEncuestaRespondida={setEncuestaRespondida}
            />
          )}
          {openModalRespuestaEncuesta && tipoRespuesta !== '' && (
            <ModalRespuestaEncuesta
              tipoRespuesta={tipoRespuesta}
              setOpenModalRespuestaEncuesta={setOpenModalRespuestaEncuesta}
              titulo={
                tipoRespuesta === 'exito'
                  ? properties.encuestaAbandono.exitoTitulo
                  : properties.encuestaAbandono.errorTitulo
              }
              descripcion={
                tipoRespuesta === 'exito'
                  ? properties.encuestaAbandono.exitoDescripcion
                  : properties.encuestaAbandono.errorDescripcion
              }
              botonAccion={tipoRespuesta === 'exito' ? volverACoopeuch : retomarEncuesta}
              botonTexto={
                tipoRespuesta === 'exito'
                  ? properties.encuestaAbandono.exitoBoton
                  : properties.encuestaAbandono.errorBoton
              }
            />
          )}
        </>
      )}
    </>
  );
};

export default Step4;
